import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelecionaEmpresaComponent } from './seleciona-empresa.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/theme/shared/shared.module';
import { SelectModule } from 'ng-select';

@NgModule({
  declarations: [
    SelecionaEmpresaComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    SelectModule
  ],
  exports: [
    SelecionaEmpresaComponent
  ]
})
export class SelecionaEmpresaModule { }
